import React, { forwardRef } from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
const useStyle = makeStyles(() => {
  return {
    input: {
      paddingTop: 3,
    },
  };
});
const CustomPhoneInput = (props, ref) => {
  const classes = useStyle();
  return (
    <TextField
      {...props}
      inputRef={ref}
      InputProps={{
        className: classes.input,
        autoComplete: 'phone',
        form: {
          autoComplete: 'off',
        },
      }}
      fullWidth
      size='small'
      label='Phone Number'
      name='phone'
      placeholder='+98'
    />
  );
};
export default forwardRef(CustomPhoneInput);
